// src/pages/PantallaTutorial.jsx

import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import fondo from '../assets/img_generales/fondo.png';

import asclepio from '../assets/img_roles/asclepio.jpg';

import demoSwipeImg from '../assets/img_roles/enfermera.jpg';

import ChatWidget from '../components/ChatWidget';

import { API_URL } from '../config.js';

import './PantallaTutorial.css';



// Helper parametrizado (evita no-undef)

function renderTypedParagraphs(text, isDone) {

  const lines = String(text || '').split('\n');

  return (

    <div className="tutorial__text">

      {lines.map((line, i) => {

        // interpreta **negrita**

        const html = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        const cursor =

          i === lines.length - 1 && !isDone

            ? '<span class="tutorial__cursor" aria-hidden="true">|</span>'

            : '';

        return (

          <p

            key={i}

            className="tutorial__p"

            dangerouslySetInnerHTML={{ __html: html + cursor }}

          />

        );

      })}

    </div>

  );

}



const DBG_TAG = '[Tutorial]';



// Texto de bienvenida (con nombre)

const fullTemplate =

  'Hola {NOMBRE}! Soy Hipócrates, médico de la antigua Grecia. Desde hoy seré tu guía en este camino de aprendizaje en radiología.\n' +

  'Durante todo el juego estaré contigo, visible en la esquina inferior derecha de tu pantalla, listo para resolver tus dudas y asesorarte en cada decisión.';



// Guion del tutorial "Cómo se juega"

const HOWTO_STEPS = [
  'Antes de comenzar, te mostraré cómo se juega.\nExisten 3 tipos de cartas:\n• **Swipe**: Desliza, suelta y confirma tocando la respuesta verde.\n• **Alternativas**: Sigue el orden numérico o elige la opción correcta.\n• **Imágenes**: Elige la imagen correcta.\n\nEl más importante es el Swipe, ¡te lo explico ahora!',
  'En las cartas tipo Swipe, mantén presionada la imagen, deslízala a la izquierda o derecha y suéltala. La carta quedará inclinada y aparecerá la respuesta en un recuadro verde.\n\n**Toca el recuadro verde para CONFIRMAR tu respuesta.** Solo entonces se contabiliza el puntaje y, si te equivocas, se descuenta un corazón.\n\nSi cambias de opinión, toca fuera del recuadro verde: la carta volverá al centro **sin registrar nada**.',
  '¡Listo! Recuerda:\n• **Swipe**: Desliza → suelta → toca el recuadro verde para confirmar. Si quieres cancelar, toca fuera.\n• **Alternativas**: Sigue el orden numérico o elige la opción correcta.\n• **Imágenes**: Elige la imagen correcta.\n\n**Un Swipe por sí solo nunca registra una respuesta.**'
];



export default function PantallaTutorial() {

  const navigate = useNavigate();

  const nombreUsuario = useMemo(

    () => (localStorage.getItem('usuario') || 'Estudiante').trim(),

    []

  );

  console.log(DBG_TAG, 'localStorage("usuario")=', nombreUsuario); // DEBUG



  // Vistas: 'intro' (pantalla base) o 'howto' (tutorial de juego)

  const [view, setView] = useState('intro');

  const [howtoStep, setHowtoStep] = useState(0);



  // Texto objetivo a tipear según vista/paso

  const introTarget = useMemo(

    () => fullTemplate.replace('{NOMBRE}', nombreUsuario),

    [nombreUsuario]

  );

  const howtoTarget = useMemo(

    () => HOWTO_STEPS[howtoStep] || HOWTO_STEPS[0],

    [howtoStep]

  );

  const textTarget = view === 'intro' ? introTarget : howtoTarget;

  console.log(DBG_TAG, 'textTarget (preview)=', textTarget.slice(0, 70) + '...');



  // Typewriter

  const [typed, setTyped] = useState('');

  const [done, setDone] = useState(false);

  const idxRef = useRef(0);

  // VELOCIDAD DEL TEXTO: milisegundos por carácter. 22 = actual; 12 = más rápido; 40 = más lento.
  const speedRef = useRef(15);

  const rafRef = useRef(null);



  const startTyping = () => {

    if (rafRef.current) cancelAnimationFrame(rafRef.current);

    setTyped('');

    setDone(false);

    idxRef.current = 0;



    let last = performance.now();

    const step = (now) => {

      if (now - last >= speedRef.current) {

        last = now;

        const n = idxRef.current + 1;

        setTyped(textTarget.slice(0, n));

        idxRef.current = n;

        if (n >= textTarget.length) {

          setDone(true);

          rafRef.current = null;

          return;

        }

      }

      rafRef.current = requestAnimationFrame(step);

    };

    rafRef.current = requestAnimationFrame(step);

  };



  useEffect(() => {

    startTyping();

    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [textTarget, view, howtoStep]);



  // Highlight del chat

  const [highlightChat, setHighlightChat] = useState(true);

  const stopHighlight = () => setHighlightChat(false);



  // === Verificación repaso + anti doble navegación ===

  const decidedRef = useRef(false); 



  const isYes = (v) =>

    String(v ?? '')

      .toLowerCase()

      .normalize('NFKD')

      .replace(/[\u0300-\u036f]/g, '')

      .trim() === 'si';



  async function continuarFlujo() {

    if (decidedRef.current) {

      console.log(DBG_TAG, 'navegación ya decidida; ignoro llamada extra');

      return;

    }

    try {

      const url = `${API_URL}/eligibilidad-repaso?nombreUsuario=${encodeURIComponent(nombreUsuario)}`;

      console.log(DBG_TAG, 'GET', url);

      const res = await fetch(url, { cache: 'no-store' });

      console.log(DBG_TAG, 'status=', res.status);

      const data = res.ok ? await res.json() : {};

      console.log(DBG_TAG, 'respuesta elegibilidad=', data);



      const cumplio =

        data?.cumplio === true ||

        isYes(data?.cumplioRepaso) ||

        isYes(data?.cumplio) ||

        isYes(data?.CumplioRepaso);



      const destino = cumplio ? '/seleccionar-nivel' : '/repaso-intro';

      console.log(DBG_TAG, 'DECISIÓN → cumplio=', cumplio, '→ navigate(', destino, ')');



      decidedRef.current = true;

      navigate(destino, { replace: true });



      setTimeout(() => {

        console.log(DBG_TAG, 'ahora en', window.location.pathname);

      }, 80);

    } catch (e) {

      console.log(DBG_TAG, 'error en continuarFlujo, fallback a /repaso-intro', e);

      decidedRef.current = true;

      navigate('/repaso-intro', { replace: true });

    }

  }



  // ===== Botones según vista =====

  const renderButtons = () => {

    if (!done) return null;



    if (view === 'intro') {

      return (

        <div className="tutorial__btnRow">

          <button className="tutorial__btn" onClick={continuarFlujo}>

            Comenzar

          </button>

          <button

            className="tutorial__btn tutorial__btn--secondary"

            onClick={() => {

              setView('howto');

              setHowtoStep(0);

            }}

          >

            Como Jugar

          </button>

        </div>

      );

    }



    // view === 'howto'

    return (

      <div className="tutorial__btnRow">

        {howtoStep < HOWTO_STEPS.length - 1 ? (

          <>

            <button

              className="tutorial__btn tutorial__btn--secondary"

              onClick={() => setView('intro')}

            >

              Volver

            </button>

            <button

              className="tutorial__btn"

              onClick={() => setHowtoStep((s) => Math.min(s + 1, HOWTO_STEPS.length - 1))}

            >

              Siguiente

            </button>

          </>

        ) : (

          <>

            <button

              className="tutorial__btn tutorial__btn--secondary"

              onClick={() => setView('intro')}

            >

              Volver

            </button>

            <button className="tutorial__btn" onClick={continuarFlujo}>

              Comenzar

            </button>

          </>

        )}

      </div>

    );

  };



  // ===== DEMO SWIPE: DESLIZAR -> SOLTAR -> CONFIRMAR -> REINICIAR =====
  // Es solo una demostración visual; no registra respuestas ni modifica vidas/puntaje.
  const [demoX, setDemoX] = useState(0);
  const [demoPhase, setDemoPhase] = useState('inicio');
  const demoRAF = useRef(null);

  useEffect(() => {
    if (view !== 'howto' || howtoStep !== 1) {
      if (demoRAF.current) cancelAnimationFrame(demoRAF.current);
      demoRAF.current = null;
      setDemoX(0);
      setDemoPhase('inicio');
      return;
    }

    // Duración total de cada demostración. Alternamos derecha e izquierda.
    const CICLO_MS = 10000;
    const DESPLAZAMIENTO = 155;
    let comienzo = null;

    const tick = (now) => {
      if (comienzo === null) comienzo = now;
      const transcurrido = now - comienzo;
      const ciclo = Math.floor(transcurrido / CICLO_MS);
      const t = transcurrido % CICLO_MS;
      const direccion = ciclo % 2 === 0 ? 1 : -1;

      if (t < 1000) {
        setDemoPhase('inicio');
        setDemoX(0);
      } else if (t < 3000) {
        setDemoPhase('deslizando');
        setDemoX(direccion * DESPLAZAMIENTO * ((t - 1000) / 2000));
      } else if (t < 6500) {
        setDemoPhase('seleccionada');
        setDemoX(direccion * DESPLAZAMIENTO);
      } else if (t < 7500) {
        setDemoPhase('confirmando');
        setDemoX(direccion * DESPLAZAMIENTO);
      } else if (t < 9000) {
        setDemoPhase('confirmada');
        setDemoX(direccion * DESPLAZAMIENTO);
      } else {
        setDemoPhase('inicio');
        setDemoX(0);
      }
      demoRAF.current = requestAnimationFrame(tick);
    };

    demoRAF.current = requestAnimationFrame(tick);
    return () => {
      if (demoRAF.current) cancelAnimationFrame(demoRAF.current);
      demoRAF.current = null;
    };
  }, [view, howtoStep]);

  const renderSwipeDemo = () => {
    if (view !== 'howto' || howtoStep !== 1) return null;

    const mostrarIzquierda = demoX < -30;
    const mostrarDerecha = demoX > 30;
    const activa = demoPhase === 'seleccionada' || demoPhase === 'confirmando' || demoPhase === 'confirmada';
    const pulsando = demoPhase === 'confirmando';

    const mensaje = demoPhase === 'inicio'
      ? '1. Desliza la carta hacia una opción.'
      : demoPhase === 'deslizando'
        ? '1. Desliza y suelta la carta.'
        : demoPhase === 'seleccionada'
          ? '2. Ahora toca el recuadro verde para confirmar.'
          : demoPhase === 'confirmando'
            ? '3. Pulsando la opción seleccionada…'
            : '¡Respuesta confirmada! Solo ahora se registra.';

    return (
      <div className="swipe-demo-equal" aria-label="Demostración animada de Swipe y confirmación">
        <p className="swipeDemo__instruccion" aria-live="off">{mensaje}</p>
        <div className="swipe-container" style={{ touchAction: 'none' }}>
          <div
            className={`opcion-izquierda ${mostrarIzquierda ? 'mostrar' : ''} ${mostrarIzquierda && activa ? 'swipeDemo__seleccionada' : ''} ${mostrarIzquierda && pulsando ? 'swipeDemo__pulsando' : ''}`}
          >
            <span>Opción A</span>
          </div>
          <div
            className={`opcion-derecha ${mostrarDerecha ? 'mostrar' : ''} ${mostrarDerecha && activa ? 'swipeDemo__seleccionada' : ''} ${mostrarDerecha && pulsando ? 'swipeDemo__pulsando' : ''}`}
          >
            <span>Opción B</span>
          </div>
          <div className="carta-deslizable">
            <div className="imagen-y-boton" style={{ position: 'relative' }}>
              <img
                draggable="false"
                src={demoSwipeImg}
                alt="Demostración de carta Swipe"
                className="img-enfermera"
                style={{
                  transform: `translateX(${demoX}px) rotate(${demoX / 30}deg)`,
                  transition: demoPhase === 'inicio' ? 'transform 0.3s ease' : 'none'
                }}
              />
            </div>
          </div>
        </div>
        <div className="swipeDemo__arrows" aria-hidden="true">
          <span className="swipeDemo__arrow swipeDemo__arrow--left">◀</span>
          <span className="swipeDemo__arrow swipeDemo__arrow--right">▶</span>
        </div>
        <p className="swipeDemo__nota">Para cancelar una selección, toca fuera del recuadro verde.</p>
      </div>
    );
  };
  return (

    <div className="tutorial__wrap" style={{ backgroundImage: `url(${fondo})` }}>

      <div className="tutorial__card" role="dialog" aria-label="Tutorial de inicio">

        <img src={asclepio} alt="Asclepio" className="tutorial__img" />



        {/* ⬇️ Usa el helper parametrizado */}

        {renderTypedParagraphs(typed, done)}



        {renderSwipeDemo()}



        {renderButtons()}

      </div>



      {/* Chat abajo derecha con highlight (se apaga al abrirlo) */}

      <div

        className={`tutorial__chatWrap ${highlightChat ? 'is-pulsing' : ''}`}

        onClick={stopHighlight}

      >

        {highlightChat && (

          <>

            <div className="arrow arrow-1" />

            <div className="arrow arrow-2" />

          </>

        )}

        <div className="tutorial__chatInner">

          <ChatWidget />

        </div>

        {highlightChat && <span className="pulse-ring" />}

      </div>

    </div>

  );

}
